module.exports = __webpack_public_path__ + "img/cliente06.29070c7d.jpg";